import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    previewContainer:{
      padding: '0',
    },
    previewList:{
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    previewListItem : {
      display: 'flex',
      flexDirection: 'column',
      width:'fit-content',
      height: 'fit-content',
    },
    previewItem:{
      width: '150px',
      height: '150px',
      overflow: 'hidden',
    },
    preview:{
      width:'100%',
      height: 'auto',
    },
    root: {
      position: 'relative',
      padding: 30,
      maxWidth: '85%',
      [theme.breakpoints.down('sm')]: {
        maxWidth: '90%',
        padding: '30px 0 80px 0',
      },
    },
    maxItens: {
      marginBottom: '20px',
    },
    quantItens:{
      marginTop: '20px',
    },
    addButtonContainer: {
      width: '100%',
      marginBottom: 15,
      flexDirection: 'column',
    },
    addButton: {
      width: 150,
      backgroundColor: 'white',
    },
    accordionContainer: {
      backgroundColor: '#eaeaea',
    },
    formGroup: {
      marginTop: 10,
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      width: 'inherit',
      maxWidth: 250,
      marginLeft: 10,
      [theme.breakpoints.up('md')]: {
        top: '160px',
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'row',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        maxWidth: 500,
        marginBottom: 15,
        marginLeft: 0,
      },
    },
    cancelIncident: {
      fontFamily: 'Texta Medium',
      color: '#f4062e',
      backgroundColor: 'white',
      minWidth: 210,
      margin: 5,
      borderColor: '#f4062e',
      '&:hover':{
        fontFamily: 'Texta Heavy',
      },
      [theme.breakpoints.down('sm')]: {
        textTransform: 'none',
        minWidth: 160
      },
    },
    saveIncident: {
      minWidth: 210,
      margin: 5,
      fontFamily: 'Texta Medium',
      letterSpacing: '1px',
      color: Colors.white,
      backgroundColor: Colors.main,
      '&:hover': {
        fontFamily: 'Texta Heavy',
        backgroundColor: Colors.secundary,
      },
      [theme.breakpoints.down('sm')]: {
        textTransform: 'none',
        minWidth: 160
      },
    },
    buttonWrapper: {
      width: '100%',
      position: 'relative',
    },
    buttonProgress: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }),
);
